/** @jsx jsx */

import { Fragment as _, memo, useMemo, useContext } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import ContentCards from './ContentCards';
import ContentCard from './ContentCard';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { interactionContext as InteractionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import getBlockById from 'services/apiHelpers/getBlockById';
import continueBtn from '../ContinueBtn/continueBtn_v2';
import { Block } from 'factories/block';
import EditableBtn from 'components/lib/EditableBtn';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import shouldUpdate from 'services/shouldUpdate';
import { imgPlaceholders } from 'components/lib/Image';
import cardPlaceholderImg from 'assets/Short Rectangle.svg';
import { ImageContext } from 'components/lib/Image';
import longRectangle from 'assets/Long Rectangle.svg';

const Components = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [cards, txt] = children;

    if (!includeAdditionalTextField) {
      return cards;
    }

    return (
      <_>
        {cards}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  ContentCards,
  ContentCard({ children, ...props }) {
    return (
      <ImageContext.Provider
        value={{
          editWrapperType: 1,
          editWrapperSize: '90%',
          placeholder: cardPlaceholderImg || imgPlaceholders[0],
        }}
      >
        <ContentCard {...props}>{children}</ContentCard>
      </ImageContext.Provider>
    );
  },
  ColumnRowA: ({ children, ...props }) => children,
  ColumnRowB: ({ children, ...props }) => children,

  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: longRectangle || imgPlaceholders[1],
        }}
      />
    );
  },
  Video,
  Audio,
  Transcript: () => null,
  SVG,
  PDF,
  OpenPDF,
  Embed,
  Media,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: continueBtn,
  EditableButton: EditableBtn,
};

const ContentCardDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider value={{ ...interactionBlock }}>
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default ContentCardDisplay;
